(function () {
  'use strict';

  const TRIGGER_VARIANT_ID = 48991626952953;
  const TRIGGER_PRODUCT_ID = 10245466030329;
  const DHL_US_PRICE_CENTS = 19000;
  const CART_MUTATION_PATH = /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/;
  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartUrl = `${shopRoot}cart.js`;
  const addUrl = `${shopRoot}cart/add.js`;
  const changeUrl = `${shopRoot}cart/change.js`;
  const nativeFetch = window.fetch.bind(window);
  let syncQueue = Promise.resolve();
  let syncing = false;
  let presentationTimer;

  function requestPath(input) {
    try {
      const value = typeof input === 'string' ? input : input && input.url;
      const url = new URL(value, window.location.origin);
      return url.pathname + url.search;
    } catch (error) {
      return '';
    }
  }

  function propertyValue(properties, name) {
    if (!properties) return '';
    const target = name.toLowerCase();
    const key = Object.keys(properties).find((item) => item.toLowerCase() === target);
    return key ? String(properties[key] || '') : '';
  }

  function parseWidth(value) {
    const match = String(value).match(/Width:\s*(\d+(?:\.\d+)?)\s*(?:(\d+)\s*\/\s*(\d+))?/i);
    if (!match) return NaN;

    const whole = Number(match[1]);
    const numerator = Number(match[2] || 0);
    const denominator = Number(match[3] || 1);
    return whole + (denominator ? numerator / denominator : 0);
  }

  function lineRequiresDhl(item) {
    if (Number(item.variant_id) === TRIGGER_VARIANT_ID) return false;

    const delivery = propertyValue(item.properties, 'PICK UP or DELIVERY');
    if (!/Delivery to my door/i.test(delivery)) return false;

    const direction = propertyValue(item.properties, 'OPEN DIRECTION');
    const width = parseWidth(propertyValue(item.properties, 'DIMENSIONS'));
    if (!Number.isFinite(width)) return false;

    if (/OPENS BOTH SIDES/i.test(direction)) return width >= 213 && width <= 236;
    if (/OPENS TO THE (LEFT|RIGHT)/i.test(direction)) return width >= 107 && width <= 118;
    return false;
  }

  async function fetchJson(url, options) {
    const response = await nativeFetch(url, options);
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  }

  async function changeLine(key, quantity) {
    return fetchJson(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  function countryCode(currency) {
    const shopifyCountry = String((window.Shopify && window.Shopify.country) || '').toUpperCase();
    if (shopifyCountry) return shopifyCountry;
    if (currency === 'USD') return 'US';
    if (currency === 'CAD') return 'CA';
    return '';
  }

  function currencyCode(cart) {
    return (cart && cart.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol'
      }).format(cents / 100) + ' ' + currency;
    } catch (error) {
      return '$' + (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function dhlBadge() {
    return '<span class="dhl-oversize__logo" role="img" aria-label="DHL">DHL</span>';
  }

  function ensurePresentationStyles() {
    if (document.getElementById('dhl-oversize-presentation-styles')) return;
    const style = document.createElement('style');
    style.id = 'dhl-oversize-presentation-styles';
    style.textContent = `
      .dhl-oversize__logo{display:inline-flex;align-items:center;justify-content:center;width:100%;height:100%;min-height:58px;padding:8px;background:#ffcc00;color:#d40511;font:italic 900 22px/1 Arial,sans-serif;letter-spacing:-2px;border-radius:4px;box-sizing:border-box}
      .dhl-oversize-row .m-cart-item__info{display:flex!important;min-width:0;flex:1;flex-direction:column;align-items:flex-start}
      .dhl-oversize__note{width:100%;max-width:440px;margin:7px 0 0;color:#475569;font-size:13px;line-height:1.45}
      .dhl-oversize__price{color:#103b67;font-weight:700;line-height:1.35}
      .dhl-oversize__automatic{display:inline-block;padding:5px 10px;border-radius:999px;background:#eef4f8;color:#103b67;font-size:12px;font-weight:700}
      .dhl-oversize__summary-row{display:flex;justify-content:space-between;gap:18px;margin:7px 0;color:#103b67;font-weight:700}
      .dhl-oversize__estimated-total{padding-top:9px;border-top:1px solid #cbd5df;font-size:1.08em}
      @media print{.dhl-oversize__logo{min-height:42px!important;font-size:18px!important;-webkit-print-color-adjust:exact;print-color-adjust:exact}.dhl-oversize__note{font-size:9px!important}.dhl-oversize__automatic{padding:0!important;background:transparent!important}.dhl-oversize__summary-row{font-size:11px!important}.dhl-oversize__estimated-total{font-size:14px!important}}
    `;
    document.head.appendChild(style);
  }

  function triggerRows() {
    const productSelector = `[data-product-id="${TRIGGER_PRODUCT_ID}"]`;
    const variantSelector = `[data-quantity-variant-id="${TRIGGER_VARIANT_ID}"]`;
    const rows = Array.from(document.querySelectorAll(productSelector));
    document.querySelectorAll(variantSelector).forEach((input) => {
      const row = input.closest('[data-cart-item], .m-cart-item');
      if (row && !rows.includes(row)) rows.push(row);
    });
    return rows;
  }

  function decorateTriggerRow(row, country, currency) {
    const isUs = country === 'US';
    const isCanada = country === 'CA';
    const priceText = isUs ? money(DHL_US_PRICE_CENTS, currency) + ' at checkout' : (isCanada ? 'FREE in Canada' : 'Calculated at checkout');
    const explanation = isUs
      ? 'Required DHL delivery for an oversized one-piece track. The $190 shipping charge is added once per order at checkout.'
      : (isCanada
        ? 'Required carrier marker for an oversized one-piece track. Delivery is free within Canada.'
        : 'Required carrier marker for an oversized one-piece track. Final delivery cost is shown at checkout.');

    row.classList.add('dhl-oversize-row');
    const image = row.querySelector('.m-cart-item__image');
    if (image && !image.querySelector('.dhl-oversize__logo')) image.innerHTML = dhlBadge();
    const title = row.querySelector('[data-role="product-title"], .m-cart-item__title');
    if (title) {
      title.textContent = 'DHL Oversize Track Delivery';
      title.removeAttribute('href');
      if (!title.parentElement.querySelector('.dhl-oversize__note')) {
        title.insertAdjacentHTML('afterend', `<p class="dhl-oversize__note">${explanation}</p>`);
      } else {
        title.parentElement.querySelector('.dhl-oversize__note').textContent = explanation;
      }
    }
    row.querySelectorAll('.m-cart__column--price, .m-cart__column--subtotal').forEach((column) => {
      if (column.querySelector('.dhl-oversize__price')?.textContent === priceText) return;
      column.innerHTML = `<div class="dhl-oversize__price">${priceText}</div>`;
    });
    const quantity = row.querySelector('.m-cart__column--quantity');
    if (quantity && !quantity.querySelector('.dhl-oversize__automatic')) quantity.innerHTML = '<span class="dhl-oversize__automatic">Automatic</span>';
    row.querySelectorAll('m-cart-remove-button, .m-cart-item__remove, foxkit-incart-upsell').forEach((element) => element.remove());
  }

  function updateSummary(cart, country, currency) {
    const summary = document.querySelector('.m-cart__summary');
    if (!summary) return;
    summary.querySelectorAll('.dhl-oversize__summary-row').forEach((node) => node.remove());
    if (!cart.items.some((item) => Number(item.variant_id) === TRIGGER_VARIANT_ID)) return;

    const subtotal = summary.querySelector('.m-cart__subtotal');
    if (!subtotal) return;
    const isUs = country === 'US';
    const isCanada = country === 'CA';
    const shippingCents = isUs ? DHL_US_PRICE_CENTS : 0;
    const shippingText = isUs ? money(shippingCents, currency) : (isCanada ? 'FREE' : 'Calculated at checkout');
    subtotal.insertAdjacentHTML('afterend', `<div class="dhl-oversize__summary-row"><span>DHL oversize delivery</span><span>${shippingText}</span></div>`);
    if (isUs || isCanada) {
      const total = cart.total_price + shippingCents;
      summary.insertAdjacentHTML('beforeend', `<div class="dhl-oversize__summary-row dhl-oversize__estimated-total"><span>Estimated total${isUs ? ' including DHL' : ''}</span><span>${money(total, currency)}</span></div>`);
    }
  }

  function updateQuoteTerms(country) {
    const shippingLine = Array.from(document.querySelectorAll('.m-quote-print-terms p')).find((p) => /^Shipping:/i.test(p.textContent.trim()));
    if (!shippingLine) return;
    if (country === 'US') shippingLine.innerHTML = '<strong>Shipping:</strong> DHL oversize track delivery — $190.00, included in the estimated total above.';
    else if (country === 'CA') shippingLine.innerHTML = '<strong>Shipping:</strong> Free within Canada, including qualifying oversized tracks.';
  }

  async function updateDhlPresentation(cart) {
    if (!document.querySelector('[data-minimog-cart-items], .m-cart, .m-cart-drawer')) return;
    try {
      const currentCart = cart || await fetchJson(cartUrl, { headers: { Accept: 'application/json' } });
      const currency = currencyCode(currentCart);
      const country = countryCode(currency);
      ensurePresentationStyles();
      triggerRows().forEach((row) => decorateTriggerRow(row, country, currency));
      updateSummary(currentCart, country, currency);
      updateQuoteTerms(country);
    } catch (error) {
      console.error('[DHL cart presentation]', error);
    }
  }

  function schedulePresentation(cart) {
    window.clearTimeout(presentationTimer);
    presentationTimer = window.setTimeout(() => updateDhlPresentation(cart), 60);
  }

  async function synchronizeDhlTrigger() {
    if (syncing) return;
    syncing = true;

    try {
      let cart = await fetchJson(cartUrl, { headers: { Accept: 'application/json' } });
      const triggerLines = cart.items.filter((item) => Number(item.variant_id) === TRIGGER_VARIANT_ID);
      const needsTrigger = cart.items.some(lineRequiresDhl);

      if (needsTrigger && triggerLines.length === 0) {
        cart = await fetchJson(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: TRIGGER_VARIANT_ID, quantity: 1 }] })
        });
      } else if (!needsTrigger && triggerLines.length) {
        for (const line of triggerLines) cart = await changeLine(line.key, 0);
      } else if (needsTrigger && triggerLines.length) {
        cart = await changeLine(triggerLines[0].key, 1);
        for (const line of triggerLines.slice(1)) cart = await changeLine(line.key, 0);
      }
      schedulePresentation(cart && Array.isArray(cart.items) ? cart : null);
    } catch (error) {
      console.error('[DHL oversize shipping]', error);
    } finally {
      syncing = false;
    }
  }

  function queueSynchronization() {
    syncQueue = syncQueue.catch(function () {}).then(synchronizeDhlTrigger);
    return syncQueue;
  }

  window.fetch = async function () {
    const args = Array.prototype.slice.call(arguments);
    const response = await nativeFetch.apply(null, args);
    if (response.ok && CART_MUTATION_PATH.test(requestPath(args[0]))) await queueSynchronization();
    return response;
  };

  const NativeXMLHttpRequest = window.XMLHttpRequest;
  if (NativeXMLHttpRequest) {
    const nativeOpen = NativeXMLHttpRequest.prototype.open;
    NativeXMLHttpRequest.prototype.open = function (method, url) {
      this.__dhlCartMutation = CART_MUTATION_PATH.test(requestPath(url));
      if (this.__dhlCartMutation) {
        this.addEventListener('loadend', function () {
          if (this.status >= 200 && this.status < 400) queueSynchronization();
        });
      }
      return nativeOpen.apply(this, arguments);
    };
  }

  function start() {
    queueSynchronization();
    schedulePresentation();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
